const useExclusiveOption = (value: string[], exclusiveKey: string) => ({
  isExclusiveSelected: value.includes(exclusiveKey),
  isAnyNonExclusiveSelected: value.some((v) => v !== exclusiveKey),
});

export default useExclusiveOption;
